import { sessionTimeoutModuleName } from '@layout/session-timeout/models/session-timeout-module-name';

export class SessionTimeoutTestIds {
  static logoutButton = `${sessionTimeoutModuleName}-button-logout`;
  static resumeSessionButton = `${sessionTimeoutModuleName}-button-resume-session`;
}
